import { call, getContext, select } from 'redux-saga/effects';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { checkPublish as checkPublishRequest, TCheckPublishResult } from '../../../../services/checkPublish';
import { IAppState } from '../../../types';
import { ITelemetryService } from '../../../../types/telemetryService';
import { getCheckServiceParams } from '../../checkoutInfo/checkService/utils';
import { ICheckPublishTermSchema } from '../../../../repositories/monolith-python/entities/CheckPublishTermSchema';
import { selectConfigValue } from '../../../../selectors/config';

export function* checkPublish(terms: Array<ICheckPublishTermSchema>) {
  const httpApi: IHttpApi = yield getContext('httpApi');
  const logger: ILogger = yield getContext('logger');
  const telemetryService: ITelemetryService = yield getContext('telemetryService');
  const state: IAppState = yield select();

  const { offer, user, checkoutInfo } = state;

  const parameters = getCheckServiceParams({
    offer,
    user,
    checkoutInfo,
    terms,
    isServiceChanged: false,
  });

  const subdomain = selectConfigValue('subdomain', state) as string;

  const result: Promise<TCheckPublishResult> = yield call(checkPublishRequest, {
    httpApi,
    logger,
    telemetryService,
    parameters,
    subdomain,
  });

  return result;
}
